"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionItem = void 0;

var _index = require("../../atoms/Avatar/index");

var _styles = require("./styles");

var _nullIcon = _interopRequireDefault(require("../../../assets/images/versionSelector/nullIcon.svg"));

var _acceptIcon = _interopRequireDefault(require("../../../assets/images/versionSelector/acceptIcon.svg"));

var _versionSelected = _interopRequireDefault(require("../../../assets/images/versionSelector/versionSelected.svg"));

var _GeneralButton = require("../../atoms/GeneralButton");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _jsxRuntime = require("react/jsx-runtime");

var VersionItem = function VersionItem(_ref) {
  var _ref$version = _ref.version,
      version = _ref$version === void 0 ? "" : _ref$version,
      articleStatus = _ref.articleStatus,
      currentVersion = _ref.currentVersion,
      _ref$productOwner = _ref.productOwner,
      productOwner = _ref$productOwner === void 0 ? "owner test" : _ref$productOwner,
      setVersion = _ref.setVersion,
      timestamp = _ref.timestamp;
  var textExportedDate = "";

  if (timestamp !== null) {
    var exportedDate = new Date(timestamp).toLocaleDateString();
    textExportedDate = "\xDAltima vez exportado: ".concat(exportedDate);
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "header",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
        buttonType: "circular-button" + (currentVersion ? " disabled" : ""),
        image: _versionSelected.default,
        onClick: function onClick() {
          return setVersion && setVersion(version);
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: articleStatus ? _acceptIcon.default : _nullIcon.default,
        alt: articleStatus ? "Validated version" : "Unvalidated version"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "version-info",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        text: "Versión " + version,
        headerType: "input-name-header",
        color: _variables.GlobalColors.magenta_s2
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: textExportedDate
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: currentVersion ? "Versión actual" : articleStatus ? "Edición Content-Oh!" : "Versión de " + productOwner
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: articleStatus ? "Content-Oh! digital" : productOwner
      })]
    })]
  });
};

exports.VersionItem = VersionItem;